<script setup lang="ts">
import { computed } from 'vue';
import { Input } from "@/core/components/ui/input";

const value = defineModel<string | null | undefined>();
defineEmits(["on-update"]);

const timeValue = computed({
    get: () => value.value ?? '',
    set: (newValue: string) => {
        value.value = newValue === '' ? null : newValue;
    }
});
</script>

<template>
  <Input v-model="timeValue" type="time" @update:model-value="$emit('on-update')" />
</template>
